module.exports = __webpack_public_path__ + "static/media/deal-1.347d6fbe.png";